import { queryOptions } from '@tanstack/react-query';

import { globalSearch } from './customApi';
import type { GlobalSearchRequest } from './schema';

const GLOBAL_SEARCH_KEY = 'globalSearch';

export const globalSearchQueries = {
  all: () => [GLOBAL_SEARCH_KEY] as const,

  search: (request: GlobalSearchRequest) =>
    queryOptions({
      queryKey: [GLOBAL_SEARCH_KEY, request] as const,
      queryFn: () => globalSearch(request)
    })
};
